import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AudanetInegrationRoutingModule } from './audanet-integration-routing.module';
import { ShowAssociatedAudanetTasksComponent } from './components/show-associated-audanet-tasks/show-associated-audanet-tasks.component';
import { ShowAudanetTaskDetailsComponent } from './components/show-audanet-task-details/show-audanet-task-details.component';
import { ShowCalculationDetailsComponent } from './components/show-calculation-details/show-calculation-details.component';
import { ExportDocumentsToAudanetComponent } from './components/export-documents-to-audanet/export-documents-to-audanet.component';


const sharedComponents = 
[
  ShowAssociatedAudanetTasksComponent,
  ShowAudanetTaskDetailsComponent,
  ShowCalculationDetailsComponent,
  ExportDocumentsToAudanetComponent,
];

@NgModule({
  declarations: [
    sharedComponents,
  ],
  imports: [
    AudanetInegrationRoutingModule,
    SharedModule,
  ],
  exports: [
    sharedComponents
  ]
})
export class AudanetIntegrationModule { }
